// export default ManageItems;
import React, { useState, useEffect, useContext } from "react";

import { Link } from "react-router-dom";
import { Stepper, Step } from "react-form-stepper";
import StepWizard from "react-step-wizard";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import ItemInfo from "./ItemInfo";
import Images from "./Images";
import Inventory from "./Inventory";
import Pricing from "./Pricing";
import Locations from "./Locations";
import {AppContext} from "../../../../context/AppContext";
// import ItemsDetail from "./ItemsDetails";
// import ItemsRack from "./ItemsRack";

const ManageItems = () => {
  const [loading, setLoading] = useState(false);
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [data, setData] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const {itemdata} = useContext(AppContext)


  console.log(itemdata?itemdata : [],"5512" );
  

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const callbackListofdata = (val) => {
    setData(val);
  };

  const assignUser = (val) => {
    setUser((user) => ({
      ...user,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    setActiveStep(e.activeStep - 1);
  };

  const handleComplete = () => {
    alert("You r done. TQ");
  };

  useEffect(() => {
    if (stepWizard !== null) {
      console.log(stepWizard, "stepWizard");
      setActiveStep(stepWizard.currentStep - 1);
    }
  }, [stepWizard, activeStep]);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* <div className="row" style={{ marginTop: "-1.5rem" }}>
            <div
              className="col"
              style={{ display: "flex", alignItems: "baseline", gap: "1.5rem" }}
            >
              <span className="page-title m-0 p-0">New Item</span>
              {"  "}
              <span>
                <Link to="/dashboard">Dashboard</Link> /{" "}
                <Link to="/items">Items List</Link> / Manage Items
              </span>
            </div>
          </div> */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position" >
              {/* <h3 className="page-title">New Item</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/items">Items List </Link>  / Manage Items
                </li>
              </ul>
            </div>
          </div>
          <div className="card card-body ">
  {itemdata?.Items?.length > 0 ? (
    <>
     <p style={{fontSize : "20px",fontWeight:"800"}}>  {itemdata.Items[0]?.Name}   [ID: {itemdata.Items[0]?.ID}]  </p> 
      <div style={{fontSize : "12px",fontWeight:"500",lineHeight:"2.5"}}>  {itemdata.Items[0]?.CategoryFullPath}</div>
    </>
  ) : (
   <p style={{fontSize : "20px",fontWeight:"800"}}> Item and Variations</p> 
  )}
</div>


          <div className="row" >
            <div className="col-md-12">
              <Stepper activeStep={activeStep}>
                <Step
                  onClick={() => {
                    setActiveStep(0);
                    stepWizard.goToStep(1);
                  }}
                  label="Item Info"
                  className="p-medium"
                />

                <Step
                  onClick={() => {
                    setActiveStep(1);
                    stepWizard.goToStep(2);
                  }}
                  label="Item Pricing"
                  className="p-medium"
                />
                <Step
                  onClick={() => {
                    setActiveStep(2);
                    stepWizard.goToStep(3);
                  }}
                  label="Inventory"
                  className="p-medium"
                />
                {/* <Step
                  onClick={() => {
                    setActiveStep(3);
                    stepWizard.goToStep(4);
                  }}
                  label="Item Rack"
                /> */}
                <Step
                  onClick={() => {
                    setActiveStep(3);
                    stepWizard.goToStep(4);
                  }}
                  label="Images"
                  className="p-medium"
                />
                <Step
                  onClick={() => {
                    setActiveStep(4);
                    stepWizard.goToStep(5);
                  }}
                  label="Locations"
                  className="p-medium"
                />
              </Stepper>
           {console.log(activeStep,"activestep==>>")}
              <StepWizard
                instance={assignStepWizard}
                onStepChange={handleStepChange}
                initialStep={activeStep}
              >
                {activeStep === 0 ? (
                  <ItemInfo
                    isActiveStep={activeStep === 0}
                    userCallback={assignUser}
                    Listofdata={data}
                  />
                ):(<div></div>)}
                {/* <ItemsDetail
                  isActiveStep={activeStep === 1}
                  user={user}
                  userCallback={assignUser}
                  Listofdata={data}
                  callback={callbackListofdata}
                /> */}
                {activeStep === 1 ? (
                  <Pricing
                    isActiveStep={activeStep === 1}
                    user={user}
                    userCallback={assignUser}
                    Listofdata={data}
                    callback={callbackListofdata}
                  />
                ):(<div></div>)}
                {activeStep === 2 ? (
                  <Inventory
                    isActiveStep={activeStep === 2}
                    user={user}
                    userCallback={assignUser}
                    Listofdata={data}
                    callback={callbackListofdata}
                  />
                ):(<div></div>)}
                {activeStep === 3 ? (
                  <Images
                    isActiveStep={activeStep === 3}
                    user={user}
                    userCallback={assignUser}
                    Listofdata={data}
                    callback={callbackListofdata}
                  />
                ):(<div></div>)}
                {activeStep === 4 ? (
                  <Locations
                    isActiveStep={activeStep === 4}
                    user={user}
                    completeCallback={handleComplete}
                    Listofdata={data}
                  />
                ):(<div></div>)}
              </StepWizard>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageItems;
